<template>
    <div class="w-full">
        <ResendActivationEmailContainer />
    </div>
</template>

<script>
    import ResendActivationEmailContainer from '@modules/authentication/ResendActivationEmailContainer';

    export default {
        name: 'ResendActivationEmailPage',
        components: {
            ResendActivationEmailContainer,
        },
    };
</script>
